import { motion } from "framer-motion";
import { ShieldCheck, Clock, Cpu, UserCheck } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const ICONS = [ShieldCheck, Clock, Cpu, UserCheck];

export default function WhyUs() {
  const { t } = useLanguage();
  return (
    <section
      id="pourquoi"
      data-testid="whyus-section"
      className="py-20 lg:py-32 bg-slate-950 text-white relative overflow-hidden"
    >
      <div className="absolute inset-0 blueprint-grid" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mb-14"
        >
          <div className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#E31E24] font-semibold mb-4">
            {t.whyus.overline}
          </div>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-5xl font-bold tracking-tight max-w-3xl">
            {t.whyus.title}
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {t.whyus.features.map((f, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={f.num}
                data-testid={`whyus-card-${f.num}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="group bg-slate-950 p-8 hover:bg-slate-900 transition-colors duration-300"
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon size={26} strokeWidth={1.75} className="text-[#E31E24]" />
                  <span className="font-mono-tech text-xs text-white/30 tracking-[0.2em]">
                    {f.num}
                  </span>
                </div>
                <h3 className="font-display text-lg font-semibold mb-3">{f.title}</h3>
                <p className="text-sm text-slate-400 leading-relaxed">{f.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
